angular.module('admin.gallery', [
    'admin.gallery.index',
    // 'admin.gallery.add',
    //'admin.gallery.detail'
  ]);
  


// WEBPACK FOOTER //
// ./client/src/app/admin/gallery/index.js